import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const TransporterLoginInfoComponent = ({onInnerFormChange, selectedTransporters }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Phone"
              name="Phone"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Login.Phone',
                  selectedTransporters?.Login
                )
              }}
              type="number"
              value={selectedTransporters?.Login?.Phone}
          />
      <InputContainer
              label="Email"
              name="Email"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Login.Email',
                  selectedTransporters?.Login
                )
              }}
              type="text"
              value={selectedTransporters?.Login?.Email}
          />
    </div>
 }
 expandedPanel="loginInfo"
 headerTitle="Login Info"
/>
</>
)
export default TransporterLoginInfoComponent;
